import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { UtenteLoggato } from '../../common/models/utente-loggato';
import { HelpersService } from './helpers.service';
import { AppData } from 'src/app/data-store';
import { HttpClient } from '@angular/common/http';
import { ServicePathsSettings } from '../configuration/service-paths-settings';
import { OperationsUrlSettingsSearch } from 'src/app/search/configuration/operations-url-settings-search';
import { PdaAuthService } from 'src/app/pda/utils/Service/pda-auth.service';
// import {CRSFtokenInterceptor} from "../../common/interceptors/csrftoken.interceptor";
declare var getLoggedUser;
declare var recuperaTokenCSRF;

@Injectable()
export class UserManager {
  private static requestWaiting: boolean;
  private static utenteLoggato: UtenteLoggato;
  private subjectUserLogged = new Subject<any>();
  private subjectCrsfToken = new Subject<any>();

  logout: boolean;

  constructor(private helpers: HelpersService,
    private http: HttpClient,
    private pdaAuthService: PdaAuthService
  ) {
    UserManager.requestWaiting = false;
  }

  public clearUser() {
    UserManager.requestWaiting = false;
    UserManager.utenteLoggato = null;
  }

  public getUser(): UtenteLoggato {
   let result: UtenteLoggato = null;
   if (!UserManager.utenteLoggato && !UserManager.requestWaiting) {
      UserManager.requestWaiting = true;
      this.helpers.getLoggedUserData().subscribe(response => {
        UserManager.utenteLoggato = response;
        UserManager.requestWaiting = false;
        const smUser = localStorage.getItem("TLF_USER");
        //const smDomain = localStorage.getItem("TLF_SDOMAIN");
        if (!(!!smUser /*&& !!smDomain*/)) {
          localStorage.setItem('TLF_USER', response.username);
          //localStorage.setItem('TLF_SDOMAIN', '.rete.poste');
        }
        localStorage.setItem('TLF_TENANT', response.loginTenant.id);
        this.setToken(true);

        //this.helpers.getToken().subscribe(resp => {
        //  this.setToken(resp);
        //});
      });
    }
   result = UserManager.utenteLoggato;
   return result;
  }

  setToken(token: boolean) {
    //localStorage.setItem('token', token);
    this.subjectCrsfToken.next(token)
  }

  afterToken(): Observable<any>{
    return this.subjectCrsfToken.asObservable();
  }

  sendUserLogged(isLogged: boolean) {
    this.subjectUserLogged.next(isLogged);
  }

  clearUserLogged() {
    localStorage.removeItem('TLF_USER');
    // localStorage.removeItem('TLF_SDOMAIN');
    localStorage.removeItem('TLF_TENANT');
    this.pdaAuthService.removePdaToken();
    // localStorage.removeItem('TLF_PRODUCT');
    localStorage.removeItem('token');
    localStorage.removeItem('configurations');
    AppData.getInstance().configurations = null;
    this.subjectUserLogged.next(this.isLogged());
  }

  getUserLogged(): Observable<any> {
    return this.subjectUserLogged.asObservable();
  }

  isLogged(): boolean {
    const smUser = localStorage.getItem("TLF_USER");
    //const smDomain = localStorage.getItem("TLF_SDOMAIN");
    console.log(UserManager.utenteLoggato);
    const utenteLoggato = UserManager.utenteLoggato && Object.keys(UserManager.utenteLoggato).length !== 0 && UserManager.utenteLoggato.constructor === Object;
    return (!!smUser /*&& !!smDomain*/) || utenteLoggato;
  }

  setLogout(logged) {
    this.logout = logged;
  }

  getLogout() {
    return this.logout;
  }

  getParametriCambioPwd(): Observable<{[valore:string]: 'true' | 'false'}> {
    return this.http.get<{[valore:string]: 'true' | 'false'}>(ServicePathsSettings.DOMINIO_API_GATEWAY + OperationsUrlSettingsSearch.URL_GET_CRITERI_CAMBIO_PWD)
  }

  getFlagProfiloUtente(): Observable<{[valore:string]: 'true' | 'false'}> {
    return this.http.get<{[valore:string]: 'true' | 'false'}>(ServicePathsSettings.DOMINIO_API_GATEWAY + OperationsUrlSettingsSearch.URL_GET_PROFILO_UTENTE)
  }

  getFlagMaxSizeFile(): Observable<{valore: string}> {
    return this.http.get<{valore: string}>(ServicePathsSettings.DOMINIO_API_GATEWAY + OperationsUrlSettingsSearch.URL_GET_MAX_PREVIEW_FILE_SIZE)
  }

  getFeatureConservazioneBaseUrl(): Observable<{valore: string}> {
    return this.http.get<{valore: string}>(ServicePathsSettings.DOMINIO_API_GATEWAY + OperationsUrlSettingsSearch.URL_GET_FEATURE_CONSERVAZIONE_BASE_URL)
  }
}
